<i18n src="@/locales/models/order.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-shopping-cart"></i>
      <span class="space-icon"></span>
      {{ $t("labels.orders_title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <button type="button" @click.prevent="goToNewItem" class="btn-white">
        <i class="fa-solid fa-plus"></i>
        <span class="space-icon"></span>
        {{ $t("labels.new_order_button") }}
      </button>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 620px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="orders"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="total_rows > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import { dateFilter } from "@/components/views/mixins/ag_grid_filters.js";

import Requester from "@/views/service_provider/requesters/delivery/managing/show_process.js";

import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";
import Badge from "@/components/views/layout/ag_grid/Badge.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "SPDeliveryManagingShowProcessOrders",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      orders: [],
      current_page: 1,
      total_rows: 0,
      rows_per_page: 12,

      columnDefs: [
        {
          headerName: this.$t("model.order.week"),
          field: "week",
          flex: 0.7,
        },
        {
          headerName: this.$t("model.order.order_code"),
          field: "order_code",
          flex: 1,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: this.routeName("show_order"),
                params_path: {
                  service_provider_id: this.service_provider_id,
                  delivery_process_id: this.delivery_process_id,
                  id: params.data.id,
                },
              },
            };
          },
        },
        {
          headerName: this.$t("model.order.ordered_at"),
          field: "ordered_at",
          flex: 1,
          valueFormatter: (params) =>
            this.dateFormatter(params.data.ordered_at),
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
        {
          headerName: this.$t("model.order.delivery_process_customer"),
          field: "delivery_process_customer.name",
          filter: true,
          flex: 1,
        },
        {
          headerName: this.$t("model.order.status"),
          field: "status",
          filter: true,
          flex: 1,
          cellRendererSelector: (params) => {
            return {
              component: Badge,
              params: {
                label: this.$t(`model.order.statuses.${params.value}.label`),
                bg_color: this.$t(`model.order.statuses.${params.value}.text`),
                text_color: this.$t(`model.order.statuses.${params.value}.bg`),
              },
            };
          },
        },
        {
          headerName: this.$t("model.order.delivered_at"),
          field: "delivered_at",
          flex: 1,
          valueFormatter: (params) =>
            this.dateFormatter(params.data.delivered_at),
          filter: "agDateColumnFilter",
          filterParams: dateFilter,
        },
      ],
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
  },

  created() {
    this.fetchOrders();
  },

  methods: {
    fetchOrders: async function () {
      const response = await Requester.fetchOrders(
        this.service_provider_id,
        this.delivery_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.total_rows = response.data.total_rows;
      this.orders = response.data.records;
    },

    defaultColDef: function () {
      return {
        sortable: true,
        filter: true,
        floatingFilter: true,
      };
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },

    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },

    goToNewItem: function () {
      this.$router.push({
        name: this.routeName("new_order"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
        },
      });
    },
  },

  watch: {
    current_page: async function () {
      this.load_data = false;
      await this.fetchOrders();
      this.load_data = true;
    },
  },
};
</script>
